import demo from "./modules/demo/index";

angular.module("snail", ["sn.components", demo]);


/** WEBPACK FOOTER **
 ** ./src/app.js
 **/